import type { ITableColumn } from 'types/common/table';
export const CATALOG_SETTING_COLUMNS: ITableColumn[] = [
  {
    text: 'Marketplace',
    width: 3,
    key: 'marketplace',
    textAlign: 'left',
  },
  {
    text: 'Status',
    width: 2,
    key: 'marketplace_status',
  },
  {
    text: 'Seed',
    width: 2,
    key: 'seed',
  },
  {
    text: 'Item Sync',
    width: 3,
    key: 'item_sync',
  },
  {
    text: 'Order Sync',
    width: 3,
    key: 'order_sync',
  },
  {
    text: 'Marketplace Specific',
    width: 4,
    key: 'marketplace_specific',
  },
  {
    text: '',
    width: 2,
    key: 'actions',
  },
];

export const MarketplacePriority = {
  amazon: 1,
  shopify: 2,
  walmart: 3,
  tiktok: 4,
  ebay: 5,
  etsy: 6,
  google: 7,
  facebook: 8,
  sears: 9,
  wayfair: 10,
  woocommerce: 11,
  'target plus': 12,
  temu: 13,
};
